// Helpers de formatação das telas de fichas.

const DIAS = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];

// "sex, 27/09 às 19h" — usado na linha "Abrem ...".
export function formatarAbreEm(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const diaSemana = DIAS[d.getDay()];
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const hora = String(d.getHours()).padStart(2, '0');
  return `${diaSemana}, ${dia}/${mes} às ${hora}h`;
}

// "27/09 às 19h" — versão curta (sem o dia da semana).
export function formatarDataHoraCurta(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const dia = String(d.getDate()).padStart(2, '0');
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const hora = String(d.getHours()).padStart(2, '0');
  return `${dia}/${mes} às ${hora}h`;
}